import { State, Selector, Action, StateContext } from '@ngxs/store';
import { Lines } from '../../models/line';
import { AddLines, RemoveLines } from '../actions/line.action';

export class LinesStateModel {
  lines: Lines[];
}

@State<LinesStateModel>({
  name: 'lines',
  defaults: {
    lines: [],
  },
})
export class LinesState {
  @Selector()
  getLines(state: LinesStateModel): Lines[] {
    return state.lines;
  }

  @Action(AddLines)
  add(
    { getState, patchState }: StateContext<LinesStateModel>,
    { payload }: AddLines
  ) {
    const state = getState();
    patchState({ lines: payload });
  }

  @Action(RemoveLines)
  remove({ patchState }: StateContext<LinesStateModel>) {
    patchState({ lines: [] });
  }
}
